import { AuthTokenRepository } from 'core/repositories/AuthTokenRepository';
import { Scope } from 'core/models/scope';

class DummyAuthTokenRepository implements AuthTokenRepository {
    async get(): Promise<string> {
        return 'token';
    }
    addListener(callback: (accessToken: string, expiresAt: Date) => void): void {
        callback('token', new Date());
    }
    removeListener(callback: (accessToken: string, expiresAt: Date) => void): void {
        callback('token', new Date());
    }
    async assertScope(): Promise<Scope> {
        return [];
    }
}

export { DummyAuthTokenRepository as AuthTokenRepository };
